import React from 'react';
import DoctorsCard from './DoctorsCard';
import DoctorHours from './DoctorHours';
import DoctorCustomHours from './DoctorCustomHours';
import DoctorAppointmentTypes from './DoctorAppointmentTypes';
import ClinicSettingsSectionHeader from '../../subparts/ClinicSettingsSectionHeader';

const ManageDoctor = ({ doctor, onBack }) => (
    <>
        <ClinicSettingsSectionHeader
            title={doctor?.name || 'Doctor'}
            icon="bi-person-badge"
            subtitle="Manage web booking profile, hours, and availability"
            actions={(
                <button type="button" className="btn btn-sm btn-outline-secondary rounded-pill" onClick={onBack}>
                    <i className="bi bi-arrow-left me-1"></i>
                    Back
                </button>
            )}
        />
        <div className="clinic-settings-stack">
            <DoctorsCard doctor={doctor} />
            <DoctorAppointmentTypes doctor={doctor} />
            <DoctorHours doctor={doctor} />
            <DoctorCustomHours doctor={doctor} />
        </div>
    </>
);

export default ManageDoctor;
